import { environment } from 'environments/environment';

export interface MenuSection {
    id: string;
    title: string;
    icon: string;
    route?: string;
    group?: string;
    roles?: string[];
    visible?: boolean;
    items?: MenuItem[];
    breadcrumb?: boolean;
    breadcrumb_parent?: boolean;
}

export interface MenuItem {
    title: string;
    route: string;
    mini_icon?: string;
    active_exact?: boolean;
    roles?: string[];
    visible?: boolean;
    breadcrumb?: boolean;
    breadcrumb_parent?: boolean;
}

export const MenuSections: MenuSection[] = [
    {
        visible: true,
        id: 'container-ticket_support',
        title: 'TICKET_SUPPORT.TICKET_SUPPORT',
        icon: 'fa fa-area-chart',
        group: 'primary',
        route: '/ticket_support/dashboard',
        roles: ['admin', 'super_admin', 'system'],
        breadcrumb: true,
    },
    {
        id: 'container-dashboards',
        title: 'COMMON.DASHBOARDS',
        icon: 'ni ni-chart-bar-32',
        group: 'primary',
        roles: ['admin', 'super_admin', 'system'],
        items: [
            {
                title: 'MENU.APP_SERVICE',
                route: '/app_service/dashboard',
                mini_icon: 'AXS',
                breadcrumb: true,
            },
            {
                title: 'COMMON.DISTRIBUTION_DASHBOARD',
                route: '/retirement_profile_per_user/dashboard',
                mini_icon: 'RXD',
                breadcrumb: true,
            },
            {
                title: 'COMMON.PIPELINE',
                route: '/retirement_profile_per_user/pipeline',
                mini_icon: 'RXP',
                breadcrumb: true,
            },
            {
                title: 'COMMON.PRODUCTIVITY',
                route: '/retirement_profile_per_user/productivity',
                mini_icon: 'RXY',
                breadcrumb: true,
            },
            {
                title: 'COMMON.SALES_TRACKING_DASHBOARD',
                route: '/retirement_profile_per_user/crm_dashboard',
                mini_icon: 'RXC',
                breadcrumb: true,
            },
        ]
    },
    {
        visible: true,
        id: 'container-crm_dashboard',
        title: 'COMMON.SALES_TRACKING_DASHBOARD',
        route: '/retirement_profile_per_user/crm_dashboard',
        roles: ['regional_manager', 'manager', 'external_manager'],
        icon: 'fas fa-chart-pie',
        group: 'primary',
        breadcrumb: true,
    },
    {
        visible: true,
        id: 'container-dashboard',
        title: 'COMMON.DASHBOARD',
        icon: 'ni ni-chart-pie-35',
        group: 'primary',
        route: '/retirement_profile_per_user/dashboard',
        roles: ['regional_manager', 'manager', 'external_manager'],
        breadcrumb: true,
    },
    {
        visible: true,
        id: 'container-pipeline',
        icon: 'ni ni-chart-bar-32',
        title: 'COMMON.PIPELINE',
        group: 'primary',
        route: '/retirement_profile_per_user/pipeline',
        roles: ['regional_manager', 'manager', 'external_manager'],
        breadcrumb: true,
    },
    {
        visible: true,
        id: 'container-pipeline',
        icon: 'ni ni-atom',
        title: 'COMMON.PRODUCTIVITY',
        group: 'primary',
        route: '/retirement_profile_per_user/productivity',
        roles: ['regional_manager', 'manager', 'external_manager'],
        breadcrumb: true,
    },
    {
        visible: true,
        group: 'primary',
        id: 'container-retirement_profile',
        title: 'DASHBOARD.ANALYZE_INVENTORY',
        icon: 'ni ni-collection',
        route: '/retirement_profile/dashboard',
        roles: ['admin', 'super_admin', 'system', 'regional_manager', 'manager', 'external_manager'],
        breadcrumb: true,
    },
    {
        id: 'container-retirement_profile',
        title: 'PROFILE.LIST_ASSIGNMENTS',
        icon: 'ni ni-bullet-list-67',
        group: 'primary',
        roles: ['admin', 'super_admin', 'system', 'regional_manager', 'manager', 'external_manager'],
        items: [
            {
                title: 'COMMON.LISTING',
                route: '/retirement_profile_per_user/table',
                mini_icon: 'RXP',
                breadcrumb: true,
            },
            {
                title: 'PROFILE.ASSIGNMENTS',
                route: '/retirement_profile_per_user/assign_in_bulk',
                mini_icon: 'RXA',
                breadcrumb: true,
            },
            {
                title: 'PROFILE.CHECK_ASSIGNMENTS',
                route: '/retirement_profile_per_user/check_assign_in_bulk',
                mini_icon: 'RXV',
                breadcrumb: true,
            },
            {
                title: 'PROFILE.ASSIGNMENTS_HISTORY',
                route: '/retirement_profile_per_user_history/table',
                mini_icon: 'RXH',
                breadcrumb: true,
            },
            {
                title: 'PROFILE.TRACKING',
                route: '/retirement_profile_tracking/table',
                mini_icon: 'RXT',
                breadcrumb: true,
            }
        ]
    },
    {
        visible: true,
        group: 'primary',
        id: 'container-retirement_profile',
        title: 'PROFILE.REQUESTS_WA',
        icon: 'ni ni-chat-round',
        route: '/request_retirement_profile_per_user/table',
        roles: ['admin', 'super_admin', 'system', 'regional_manager', 'manager', 'external_manager'],
        breadcrumb_parent: true,
    },
    // {
    //     visible: true,
    //     group: 'primary',
    //     id: 'container-retirement_profile_blacklist',
    //     title: 'PROFILE.BLACKLIST',
    //     icon: 'ni ni-bullet-list-67',
    //     route: '/retirement_profile_blacklist/table',
    //     roles: ['admin', 'super_admin', 'system'],
    //     breadcrumb: true,
    // },
    {
        visible: true,
        group: 'primary',
        id: 'container-retirement_profile',
        title: 'PROFILE.UNCOVER',
        icon: 'ni ni-zoom-split-in',
        route: '/retirement_profile/uncover',
        roles: ['admin', 'super_admin', 'system', 'regional_manager', 'manager', 'external_manager'],
        breadcrumb: true,
    },
    {
        visible: true,
        group: 'primary',
        id: 'container-retirement_profile',
        title: 'PROFILE.REQUESTS',
        icon: 'ni ni-send',
        route: '/request_retirement_profile/table',
        roles: ['admin', 'super_admin', 'system',],
        breadcrumb_parent: true,
    },
    // {
    //     visible: true,
    //     group: 'primary',
    //     id: 'container-retirement_profile',
    //     title: 'PROFILE.TRACKING',
    //     icon: 'ni ni-compass-04',
    //     route: '/retirement_profile_tracking/table',
    //     roles: ['admin', 'super_admin', 'system'],
    //     breadcrumb_parent: true,
    // },
    {
        visible: true,
        group: 'primary',
        id: 'container-retirement_profile',
        title: 'PROFILE.LIST_RETIREMENT',
        icon: 'ni ni-collection',
        route: '/retirement_profile/table',
        roles: ['super_admin'],
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'primary',
        id: 'container-retirement_profile_blacklist',
        title: 'PROFILE.BLACKLIST',
        icon: 'ni ni-collection',
        route: '/retirement_profile_blacklist/table',
        roles: ['super_admin'],
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'secondary',
        id: 'container-retirement_profile',
        title: 'PROFILE.MANAGEMENTS',
        icon: 'ni ni-settings-gear-65',
        route: '/management/table',
        roles: ['admin', 'super_admin', 'system'],
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'secondary',
        id: 'container-management_region',
        title: 'PROFILE.REGIONS',
        icon: 'ni ni-map-big',
        route: '/management_region/table',
        roles: ['admin', 'super_admin', 'system'],
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'secondary',
        id: 'container-management_division',
        title: 'PROFILE.DIVISIONS',
        icon: 'ni ni-collection',
        route: '/management_division/table',
        roles: ['admin', 'super_admin', 'system'],
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'secondary',
        id: 'container-management_per_management_region',
        title: 'PROFILE.MANAGEMENT_PER_MANAGEMENT_REGION',
        icon: 'fas fa-globe-americas',
        route: '/management_per_management_region/table',
        roles: ['admin', 'super_admin', 'system'],
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'secondary',
        id: 'container-management_campus',
        title: 'PROFILE.WORK_CENTERS',
        icon: 'ni ni-building',
        route: '/management_campus/table',
        roles: ['admin', 'super_admin', 'system'],
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'secondary',
        id: 'container-adviser_per_management',
        title: 'PROFILE.MY_EMPLOYMENT',
        icon: 'ni ni-badge',
        route: '/adviser_per_management/table',
        roles: ['admin', 'super_admin', 'system', 'regional_manager', 'manager', 'external_manager'],
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'secondary',
        id: 'container-adviser_per_management',
        title: 'NOTIFICATION.NOTIFICATIONS',
        icon: 'ni ni-badge',
        route: '/notification/table',
        roles: ['admin', 'super_admin', 'system'],
        breadcrumb_parent: true,
    },
    {
        id: 'container-whatsapper',
        title: 'WHATSAPPER.WHATSAPPER',
        icon: 'fa fa-whatsapp',
        group: 'secondary',
        roles: ['super_admin', 'system'],
        items: [
            {
                title: 'WHATSAPPER.GENERATE_NEW_QR',
                route: '/whatsapper/get_qr',
                mini_icon: 'WQR',
                breadcrumb: true,
            },
            {
                title: 'WHATSAPPER.SEND_MESSAGE',
                route: '/whatsapper/send_message',
                mini_icon: 'WSM',
                breadcrumb: true,
            },
            {
                title: 'WHATSAPPER.MESSAGES',
                route: '/message/list',
                mini_icon: 'WML',
                breadcrumb: true,
            },
            {
                title: 'WHATSAPPER.KEY_WORD',
                route: '/fallback_message/list',
                mini_icon: 'WFM',
                breadcrumb: true,
            },
            {
                title: 'WHATSAPPER.SETTINGS',
                route: '/whatsapper/settings',
                mini_icon: 'WTS',
                breadcrumb: true,
            },
        ]
    },
    {
        visible: true,
        group: 'secondary',
        id: 'container-users',
        title: 'PROFILE.USERS',
        icon: 'ni ni-single-02',
        route: '/user/table',
        roles: ['admin', 'super_admin', 'system'],
    },
    {
        id: 'container-permissions',
        title: 'PERMISSION.PERMISSIONS',
        icon: 'ni ni-lock-circle-open',
        group: 'secondary',
        roles: ['admin', 'super_admin', 'system'],
        items: [
            {
                title: 'PERMISSION.PERMISSION_PER_USER',
                route: '/permission_per_user/table',
                mini_icon: 'PXU',
                breadcrumb: true,
            },
            {
                title: 'PERMISSION.PERMISSIONS',
                route: '/permission/table',
                mini_icon: 'LP',
                breadcrumb: true,
            },
            {
                title: 'PERMISSION.MODULES',
                route: '/permission_module/table',
                mini_icon: 'LPM',
                breadcrumb: true,
            },
        ]
    },
    {
        id: 'container-catalogs',
        title: 'COMMON.CATALOGS',
        icon: 'ni ni-single-copy-04',
        group: 'secondary',
        roles: ['admin', 'super_admin', 'system'],
        items: [
            {
                title: 'FAQ.FAQ',
                route: '/faq/table',
                mini_icon: 'FQ',
                breadcrumb: true,
            },
            {
                title: 'SETTINGS.SETTINGS',
                route: '/app_settings/table',
                mini_icon: 'LC',
                breadcrumb: true,
            },
            {
                title: 'ADDRESS.CITIES',
                route: '/catalog_city/table',
                mini_icon: 'LC',
                breadcrumb: true,
            },
            {
                title: 'ADDRESS.STATES',
                route: '/catalog_state/table',
                mini_icon: 'LS',
                breadcrumb: true,
            },
            {
                title: 'ADDRESS.COUNTRIES',
                route: '/catalog_country/table',
                mini_icon: 'LP',
                breadcrumb: true,
            },
            {
                title: 'COMMON.JOB_POSITIONS',
                route: '/catalog_job_position/table',
                mini_icon: 'JP',
                breadcrumb: true,
            },
            {
                title: 'SETTINGS.FORMATS_NUMBER',
                route: '/catalog_format_number/table',
                mini_icon: 'LN',
                breadcrumb: true,
            },
            {
                title: 'DATE.LIST_FORMAT_DATE',
                route: '/catalog_format_date/table',
                mini_icon: 'LD',
                breadcrumb: true,
            },
            {
                title: 'SETTINGS.LANGUAGES',
                route: '/catalog_language/table',
                mini_icon: 'LC',
                breadcrumb: true,
            },

        ]
    },
    {
        visible: true,
        group: 'secondary',
        id: 'container-temp_retirement_profile',
        title: 'RETIREMENT_PROFILE.UPDATES',
        icon: 'fa fa-database',
        roles: ['super_admin', 'system'],
        items: [
            {
                title: 'RETIREMENT_PROFILE.TEMP_TABLES',
                route: '/retirement_profile/updates',
                mini_icon: 'RTU',
                breadcrumb: true,
            },
            {
                title: 'RETIREMENT_PROFILE.FULL_UPDATE_IN_BULK',
                route: '/retirement_profile/full_update_in_bulk',
                mini_icon: 'RTB',
                breadcrumb: true,
            },
        ]
    },
    {
        visible: true,
        group: 'tertiary',
        id: 'container-ticket_support',
        title: 'TICKET_SUPPORT.TICKET_SUPPORT',
        icon: 'fa fa-headset',
        route: '/ticket_support/list',
        roles: ['manager', 'regional_manager', 'external_manager'],
        breadcrumb_parent: true,
    },
    {
        id: 'container-ticket_support',
        title: 'TICKET_SUPPORT.TICKET_SUPPORT',
        icon: 'fa fa-headset',
        group: 'tertiary',
        roles: ['admin', 'super_admin', 'system'],
        items: [
            {
                title: 'TICKET_SUPPORT.TICKET_SUPPORT',
                route: '/ticket_support/table',
                mini_icon: 'TTS',
            },
            {
                title: 'TICKET_SUPPORT.TICKET_SUPPORT_TRACKING',
                route: '/ticket_support_tracking/table',
                mini_icon: 'TTR',
            },
            {
                title: 'TICKET_SUPPORT.TYPES',
                route: '/ticket_support_type/table',
                mini_icon: 'TTT',
            },
            {
                title: 'TICKET_SUPPORT.DASHBOARD',
                route: '/ticket_support/dashboard',
                mini_icon: 'TTT',
            },
        ]
    },
    {
        id: 'container-utilities',
        title: 'UTILITIES.UTILITIES',
        icon: 'fas fa-toolbox',
        group: 'tertiary',
        roles: ['admin', 'super_admin', 'system'],
        items: [
            {
                title: 'UTILITIES.PASSWORD_GENERATOR',
                route: '/utilities/password_generator',
                mini_icon: 'UPG',
                breadcrumb: true,
            },
        ]
    },
    {
        visible: true,
        group: 'tertiary',
        id: 'container-change_log',
        title: 'MENU.CHANGELOG',
        icon: 'fa fa-clipboard-list',
        route: '/change_log/table',
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'tertiary',
        id: 'container-app_settings',
        title: 'SETTINGS.SETTINGS',
        icon: 'fa fa-gears',
        route: '/app_settings/table',
        roles: ['admin', 'super_admin', 'system'],
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'tertiary',
        id: 'container-app_control_geocoder',
        title: 'APP_CONTROL_GEOCODER.APP_CONTROL_GEOCODER',
        icon: 'fa fa-globe',
        route: '/app_control_geocoder/table',
        roles: ['admin', 'super_admin', 'system'],
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'tertiary',
        id: 'container-app_logger',
        title: 'APP_LOGGER.APP_LOGGER',
        icon: 'fa fa-clipboard-check',
        route: '/app_logger/table',
        roles: ['admin', 'super_admin', 'system', 'namager'],
        breadcrumb_parent: true,
    },
    {
        visible: true,
        group: 'tertiary',
        id: 'container-api-docs/',
        title: 'MENU.DOCUMENTATION',
        icon: 'fa fa-solid fa-comments',
        route: `${environment.api}/api-docs/table`,
        roles: ['super_admin', 'system'],
        breadcrumb_parent: true,
    },
];